import {
  UpdateContactInfoInput,
  UpdateContactInfoOutput,
} from "@redotech/redo-model/order-editing/schemas/update-contact-info";

export const updateContactInfoSelfServe = {
  name: "updateContactInfoSelfServe" as const,
  input: UpdateContactInfoInput,
  output: UpdateContactInfoOutput,
};
